import React, { Component } from 'react';

class Footer extends Component {
  render() {
    const d = new Date();
    return (
      <footer className="app-footer">
        <a href="http://www.corlytics.com" tabIndex="-1">Corlytics</a> &copy; {d.getFullYear()}
      </footer>
    )
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js